<template>
    <div class='home'>
        <div class="st-header">
            <div class="container cont x-flex x-flex-center x-space-between">
                <router-link to="/" class="logo">
                    <!-- <img src="../assets/imgs/logo-lighten.svg" alt=""> -->
                </router-link>
                <div class="operation x-flex" v-if="!$store.state.userName">
                    <router-link to="/login" class="login x-bd-r x-p-r-15 x-m-r-15 c-pointer c-f">登录</router-link>
                    <router-link to="/register" class="register c-pointer c-f">注册</router-link>
                    <!-- <a href="http://www.semitronix.com/1014/987/" class="register c-pointer x-bd-l x-p-l-15 c-f" target="_black">常见问题</a> -->
                </div>
                <div v-else>
                    <router-link to="/personalCenter" class="login x-p-r-15 x-m-r-15 x-bd-r c-pointer c-f"><i class="el-icon-user-solid x-m-r-10"></i>{{$store.state.userName}}</router-link>
                    <a href="javascript:;" class="register c-pointer c-f x-m-r-15" @click="fLogout">退出登录</a>
                    <router-link v-if="$route.path != '/problemSubmitList'" to="/problemSubmitList" class="register x-bd-l x-p-l-15 x-p-r-15 c-pointer c-f">提交建议</router-link>
                    <!-- <a v-if="$route.path == '/problemSubmitList'" class="register x-bd-l x-p-l-15 x-m-r-15 c-pointer c-f" @click="fGetDataList">问题导出</a> -->
                    <!-- <a href="http://www.semitronix.com/1014/987/" class="register c-pointer x-bd-l x-p-l-15 c-f" target="_black">常见问题</a> -->
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    methods: {
        fLogout() {
            this.$alert("确认退出？", "退出登录", {
                callback: (val) => {
                    if (val == "confirm") {
                        window.sessionStorage.removeItem("userCode");
                        window.sessionStorage.removeItem("userCompany");
                        window.sessionStorage.removeItem("userName");
                        window.sessionStorage.removeItem("token");
                        window.sessionStorage.removeItem("userId");
                        this.$store.commit("setUserName", "");
                        this.$store.commit("setUserCode", "");
                        this.$store.commit("setUserCompany", "");
                        this.$store.commit("setToken", "");
                        this.$store.commit("setUserId", "");
                        this.$router.push("/login");
                    }
                },
            });
        },
    },
};
</script>

<style scoped lang='less'>
.home {
    .st-header {
        width: 100%;
        height: 80px;
        background-image: url("../assets/imgs/header-bgimg.jpg");
        .cont {
            height: 100%;
            .logo img {
                width: 120px;
            }
            .operation {
                font-size: 16px;
                line-height: 16px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue